import { AxiosInstance } from 'axios';
import { VehicleBodyTypeLiterals, VehicleWeightClass } from '@trukt/types/Vehicle';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';

export type VehicleBodyTypesSearchRequest = PaginatedQueryParams;
export type VehicleBodyTypesSearchResponse = PaginatedResults<{ type: VehicleBodyTypeLiterals }>;

export type VehicleBodyWeightClassSearchRequest = PaginatedQueryParams;
export type VehicleBodyWeightClassSearchResponse = PaginatedResults<VehicleWeightClass>;

export class VehicleService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  searchBodyTypes(request: VehicleBodyTypesSearchRequest) {
    return this.instance.get<VehicleBodyTypesSearchResponse>('/vehicles/body-types', {
      params: request,
    });
  }

  searchWeightClass(request: VehicleBodyWeightClassSearchRequest) {
    return this.instance.get<VehicleBodyWeightClassSearchResponse>('/vehicles/weight-classes', {
      params: request,
    });
  }
}
